import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError, AxiosResponse } from 'axios'
import { fetchDataFromApi } from '../services/fetchDataFromApi.tsx'
import { NwTitle } from '../types/settingTypes/NwTitle.tsx'
import { Salutations } from '../types/settingTypes/Salutation.tsx'
import { NwFileType } from '../types/settingTypes/NwFileType.tsx'

interface SettingState {
  titleList: NwTitle[] | null
  besanList: Salutations[] | null
  fileTypeList: NwFileType[] | undefined
  loading: 'idle' | 'pending' | 'succeeded' | 'failed'
  error: string | null
  statusCode: number | null
}

interface FetchApiDataOptions {
  url: string
  token: string
  method?: string
}

const initialState: SettingState = {
  titleList: null,
  besanList: null,
  fileTypeList: undefined,
  loading: 'idle',
  error: null,
  statusCode: null,
}

//BESAN = Anreden
export const fetchBesanFromApiData = createAsyncThunk('api/fetchBesanFromApiData', async ({ url, token }: FetchApiDataOptions) => {
  try {
    const data: AxiosResponse | AxiosError = await fetchDataFromApi(url, token)
    return data
  } catch (error: any) {
    // Fehlerbehandlung
  }
})

// Titles
export const fetchTitlesFromApiData = createAsyncThunk('api/fetchTitlesFromApiData', async ({ url, token }: FetchApiDataOptions) => {
  try {
    const data: AxiosResponse | AxiosError = await fetchDataFromApi(url, token)
    return data
  } catch (error: any) {
    // Fehlerbehandlung
  }
})

// File typen
export const fetchFileTypesFromApiData = createAsyncThunk('api/fetchFileTypesFromApiData', async ({ url, token }: FetchApiDataOptions) => {
  try {
    const data: AxiosResponse | AxiosError = await fetchDataFromApi(url, token)
    return data
  } catch (error: any) {
    // Fehlerbehandlung
  }
})

const settingSlice = createSlice({
  name: 'settingStore',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      //Anreden
      .addCase(fetchBesanFromApiData.pending, (state) => {
        state.loading = 'pending'
      })
      .addCase(fetchBesanFromApiData.fulfilled, (state, action) => {
        const result = action.payload
        if (result instanceof AxiosError) {
          if (result?.status < 200 || result.status >= 300) {
            state.statusCode = result.status
          } else if (result.code === 'ERR_NETWORK') {
            state.statusCode = 503
          } else if (result.code === 'ERR_BAD_REQUEST') {
            state.statusCode = 403
          } else {
            state.statusCode = result.status
          }
          state.loading = 'failed'
          state.error = result.statusText
        } else if (result) {
          state.loading = 'succeeded'
          state.besanList = action.payload?.data
          state.statusCode = result.status
        }
      })
      .addCase(fetchBesanFromApiData.rejected, (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message || 'An error occurred'
      })

      //Titles
      .addCase(fetchTitlesFromApiData.pending, (state) => {
        state.loading = 'pending'
      })
      .addCase(fetchTitlesFromApiData.fulfilled, (state, action) => {
        const result = action.payload
        if (result instanceof AxiosError) {
          if (result?.status < 200 || result.status >= 300) {
            state.statusCode = result.status
          } else if (result.code === 'ERR_NETWORK') {
            state.statusCode = 503
          } else if (result.code === 'ERR_BAD_REQUEST') {
            state.statusCode = 403
          } else {
            state.statusCode = result.status
          }
          state.loading = 'failed'
          state.error = result.statusText
        } else if (result) {
          state.loading = 'succeeded'
          state.titleList = action.payload?.data
          state.statusCode = result.status
        }
      })
      .addCase(fetchTitlesFromApiData.rejected, (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message || 'An error occurred'
      })

      // File Typen
      .addCase(fetchFileTypesFromApiData.pending, (state) => {
        state.loading = 'pending'
      })
      .addCase(fetchFileTypesFromApiData.fulfilled, (state, action) => {
        const result = action.payload
        if (result instanceof AxiosError) {
          if (result?.status < 200 || result.status >= 300) {
            state.statusCode = result.status
          } else if (result.code === 'ERR_NETWORK') {
            state.statusCode = 503
          } else if (result.code === 'ERR_BAD_REQUEST') {
            state.statusCode = 403
          } else {
            state.statusCode = result.status
          }
          state.loading = 'failed'
          state.error = result.statusText
        } else if (result) {
          state.loading = 'succeeded'
          state.fileTypeList = action.payload?.data
          state.statusCode = result.status
        }
      })
      .addCase(fetchFileTypesFromApiData.rejected, (state, action) => {
        state.loading = 'failed'
        state.error = action.error.message || 'An error occurred'
      })
  },
})
export default settingSlice.reducer
